<template>
  <div class="chart-data-page-content common-title-page">
    <div class="title-wrapper">
      <pods-input ref="podsInput"></pods-input>
      <span class="title">{{ $t('text.chart_pod_accelerometer') }}</span>
      <div class="status-table">
        <UtcOffsets />
        <el-table :data="statusData" border size="mini" class="w-242 mt-10">
          <el-table-column prop="key" label=""></el-table-column>
          <el-table-column
            prop="value"
            :label="$t('text.status')"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page-content">
      <div class="mt-10 dark-font bold-font">
        {{ $t('text.recent_data_for') }}
      </div>
      <div
        id="chart"
        class="mt-10"
        :style="{
          width: '100%',
          height: '400px'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import PodsInput from '@/components/PodsInput'
import UtcOffsets from '@/components/UtcOffsets'
import $ from 'jquery'
import moment from 'moment'
export default {
  data() {
    return {
      option: {},
      chart: '',
      source: [['timeStamp', 'ax', 'ay', 'az', 'g'], ['', 0, 0, 0, 0]]
    }
  },
  props: {
    latestCaliPodChartDataPoint: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusData() {
      return [
        {
          key: this.$t('text.position'),
          value: this.latestCaliPodChartDataPoint.position || '--'
        },
        {
          key: this.$t('text.fall'),
          value:
            typeof this.latestCaliPodChartDataPoint.fall !== 'undefined'
              ? this.latestCaliPodChartDataPoint.fall
              : '--'
        }
      ]
    }
  },
  components: {
    PodsInput,
    UtcOffsets
  },
  mounted: function() {
    $('#chart').css('width', $('.page-content').width() + 'px')
    this.initChart()
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      this.source = [['timeStamp', 'ax', 'ay', 'az', 'g'], ['', 0, 0, 0, 0]]
      this.initChart()
    },
    '$store.state.locale.currentLocale': function() {
      this.initStatusData()
    }
  },
  methods: {
    initStatusData() {
      this.statusData[0].key = this.$t('text.position')
      this.statusData[1].key = this.$t('text.fall')
    },
    updateChart() {
      //Remove initialization data
      let vm = this
      if (this.source[1][0] === '') {
        this.source.splice(1, 1)
      }
      let time = moment(this.latestCaliPodChartDataPoint.timeStamp).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.source.push([
        time,
        this.latestCaliPodChartDataPoint.ax,
        this.latestCaliPodChartDataPoint.ay,
        this.latestCaliPodChartDataPoint.az,
        this.latestCaliPodChartDataPoint.g
      ])

      this.source.forEach((item, index) => {
        //Remove more than 15 minutes data
        if (index > 0) {
          let timeDiff =
            vm.source[1][0] !== ''
              ? moment(time).diff(moment(item[0]), 'minutes')
              : 0
          if (timeDiff >= 15) {
            vm.source.splice(index, 1)
          }
        }
      })
      this.option.dataset.source = this.source
      this.chart.setOption(this.option)
    },
    initChart() {
      var dom = document.getElementById('chart')
      this.chart = this.echarts.init(dom)
      this.option = {
        grid: {
          left: 0,
          right: 30,
          bottom: 50,
          top: 20,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            let tooltipStr = `<div>${moment(params[0].axisValue)
              .add(
                moment.tz(vm.$store.state.pods.selectedUtcOffset).utcOffset() /
                  60,
                'hours'
              )
              .format('DD/MM/YY HH:mm:ss')}</div>`
            params.forEach(item => {
              if (tooltipStr.indexOf(item.color) < 0) {
                tooltipStr =
                  tooltipStr +
                  `<div><div style="display:inline-block; margin-right: 5px; width: 10px; height: 10px; border-radius: 5px; background-color:${
                    item.color
                  }"></div>${item.seriesName} : ${
                    item.value[item.seriesIndex + 1]
                  }</div>`
              }
            })
            return tooltipStr
          }
        },
        color: ['#008ffb', '#00e396', '#feb019', 'rgba(189, 25, 52, 1)'],
        legend: {
          x: 'center',
          y: 'bottom',
          data: ['Ax', 'Ay', 'Az', this.$t('text.magnitude')]
        },
        dataZoom: [
          {
            show: true,
            height: 25,
            bottom: 25,
            start: 0,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'inside'
          }
        ],
        dataset: {
          dimensions: ['timeStamp', 'ax', 'ay', 'az', 'g'],
          source: this.source
        },
        xAxis: [
          {
            type: 'time',
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function(value) {
                let time = value
                  ? moment(value).add(
                      moment
                        .tz(vm.$store.state.pods.selectedUtcOffset)
                        .utcOffset() / 60,
                      'hours'
                    )
                  : ''
                return time.format('HH:mm:ss') + '\n' + time.format('DD/MM/YY')
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            nameLocation: 'center',
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series: [
          {
            name: 'Ax',
            type: 'line',
            symbol: 'circle',
            encode: {
              x: 'timeStamp',
              y: 'ax'
            }
          },
          {
            name: 'Ay',
            type: 'line',
            symbol: 'circle',
            encode: {
              x: 'timeStamp',
              y: 'ay'
            }
          },
          {
            name: 'Az',
            type: 'line',
            symbol: 'circle',
            encode: {
              x: 'timeStamp',
              y: 'az'
            }
          },
          {
            name: this.$t('text.magnitude'),
            type: 'line',
            symbol: 'circle',
            encode: {
              x: 'timeStamp',
              y: 'g'
            }
          }
        ]
      }
      this.chart.setOption(this.option)
      let vm = this
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    }
  }
}
</script>
